import {DacConfig} from '../../shared/services/dac-config.service';
import {NavBarItem} from '../../theme/models/nav-bar-item';
import {NavBarService} from '../../theme/services/nav-bar.service';
import {UniqueIdService} from '../../shared/services/unique-id.service';
import {FlaggedQuestionsListComponent} from '../report-items/flagged-questions-list/flagged-questions-list.component';
import {IReportItemComponent} from "../models/i-report-item-component";
import {HtmlContentItemComponent } from "../report-items/html-content-item/html-content-item.component";
import {ScaleResultsSectionsListComponent } from "../report-items/scale-results-sections-list/scale-results-sections-list.component";
import {TextItemComponent} from "../text-item/text-item.component";
import {ComputedScaleComponent} from "../report-items/computed-scale/computed-scale.component";

import {AssessmentResult} from "../../shared/models/assessment-result";
import {AssessmentService} from "../../shared/services/assessment.service";
import {ClientService} from "../../shared/services/client.service"
import {Variable} from "../models/variable";
import {ResultComputation} from "../models/result-computation";
import {AddoScaleResultsComponent} from "../report-items/addo-scale-results/addo-scale-results.component";

import {Assessment} from "../../shared/models/assessment";
import {ScaleResult} from "../../shared/models/scale-result";
import { AssessmentHydrator } from "../../shared/services/assessment-hydrator.service";
import { ReportService } from "../services/report.service";

import { Component, OnInit
  , ViewChild, ViewContainerRef
  , ComponentFactoryResolver, ComponentFactory
  , ComponentRef,
  OnDestroy,
  ElementRef
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ScaleResultsSummaryComponent } from "app/reports/report-items/scale-results-summary/scale-results-summary.component";
import { TherapistScaleResultsComponent } from "app/reports/report-items/therapist-scale-results/therapist-scale-results.component";
import { PclAssessmentResultsComponent } from 'app/reports/report-items/pcl-assessment-results/pcl-assessment-results.component';
import { Subscription } from 'rxjs/Subscription';
import { AssessmentQuestionsListComponent } from 'app/reports/report-items/assessment-questions-list/assessment-questions-list.component';
import { PrintSettings } from 'app/reports/models/print-settings';

import 'rxjs/add/observable/fromPromise';
import { QuestionActionListComponent } from '../report-items/question-action-list/question-action-list.component';
import { ClientScaleResultsComponent } from '../report-items/client-scale-results/client-scale-results.component';
import { SsoCrossDomainMessenger } from 'app/shared/services/sso-cross-domain-messenger';
import { FlaggedQuestionsListSimpleComponent } from '../report-items/flagged-questions-list-simple/flagged-questions-list-simple.component';
import { Assignment } from 'app/shared/models/Assignment';
import { ManagedClient } from 'app/shared/models/managed-client';


@Component({
  selector: 'dac-report-viewer',
  templateUrl: './report-viewer.component.html',
  host: {'class': 'row d-print-block-visible'}
})
export class ReportViewerComponent implements OnInit, OnDestroy {

  @ViewChild("container", { read: ViewContainerRef }) container;
  private _reportData:any;
  public menuItems:{id:string, name:string, hasIcon:boolean, iconClasses:string[]}[];
  private componentItems:ComponentRef<IReportItemComponent>[];
  private componentItemsById:Map<string, ComponentRef<IReportItemComponent>>;
  public hasLoadedResults:boolean;
  private _reportItemClassNames = ["report-item-component"];
  public assignment:Assignment;

  /**
   * Whether to show therapist note information in the report.  Otherwise it's hidden so it can be
   * given to a client or print off a shorter report.
   */
  public displayTherapistNotes:boolean;

  public reportId:string;
  
  /**
   * Whether to show the print dialog or not.
   */
  public showPrintDialog:boolean;

  private routeParamsSubscription:Subscription;
  private navBarSubscription:Subscription;
  private queryParamsSubscription:Subscription;

 constructor(private resolver: ComponentFactoryResolver
 ,private assessmentService:AssessmentService
 ,private clientService:ClientService
 ,private hydrator:AssessmentHydrator
 ,private route:ActivatedRoute
 ,private reportService:ReportService
 ,private uniqueIdService:UniqueIdService
 ,private navBarService:NavBarService
 ,private dacConfig:DacConfig
 ,private crossDomainMessenger:SsoCrossDomainMessenger
 ,private elementRef:ElementRef) {
   this.menuItems = [];
   this.componentItems = [];
   this.componentItemsById = new Map<string, ComponentRef<IReportItemComponent>>();
   this.hasLoadedResults = false;
   this.displayTherapistNotes = false;
   this.reportId = "";
 }
 
  ngOnInit() {
    this.queryParamsSubscription = this.route.queryParams.subscribe(params => {
      if (params['notes'] && params['notes'] == '1') {
        this.displayTherapistNotes = true;
      }
      else {
        this.displayTherapistNotes = false;
      }
    });
    this.routeParamsSubscription = this.route.params.subscribe(params => {
      let clientId = params['id'];
      if (!clientId || typeof clientId !== "string") {
        // this.router.navigate(['../']);
        return;
      }
      this.navBarService.setupReportSidebar(clientId);

      let reportId = params['reportId'];
      if (!reportId || typeof reportId !== "string") {
        return;
      }

      let assignmentId = +params['assignmentId'];
      if (!assignmentId || isNaN(assignmentId)) {
        return;
      }
      this.loadReport(clientId, reportId, assignmentId);
      this.navBarSubscription = this.navBarService.navBarAction.subscribe((item:NavBarItem) => {
        this.goToNavItem(item);
      });
    });
  }

  showCommandButtons() {
    return !this.dacConfig.seamlessMode;
  }

  getClasses() {
    let obj = {'display-therapist-notes': this.displayTherapistNotes};
    obj[this.reportId] = true;
    return obj;
  }

  ngOnDestroy() {
    if (this.queryParamsSubscription) {
      this.queryParamsSubscription.unsubscribe();
    }
    if (this.navBarSubscription) {
      this.navBarSubscription.unsubscribe();
    }
    if (this.routeParamsSubscription) {
      this.routeParamsSubscription.unsubscribe();
    }
    this.navBarService.clearReportSidebar();
  }

  private loadReport(clientId:string, reportId:string, assignmentId:number) {
    
    // get the client, get the reportData
    Promise.all([this.clientService.getClient(clientId), this.reportService.get(reportId)])
    .then((results) => {
      let client:ManagedClient = results[0];
      let report = results[1];
      this.reportId = reportId;
       if (!client || !client.assignments || !client.assignments.length) {
        throw new Error("No assessments to generate a report");
      }
      let assignment = client.getAssignment(assignmentId);
      if (!assignment) {
        throw new Error("Assignment could not be found with this id");
      }
      else {
        this.assignment = assignment;
      }

      if (!report) {
        throw new Error("No report data to display");
      }
      this._reportData = report;

      // TODO: stephen this is a bug as it loads ALL of the client's assessments they've taken.
      let completedResultIds = assignment.getResultIds();
      let resultPromises:Promise<AssessmentResult>[] = completedResultIds.map(r => this.assessmentService.getAssessmentResult(clientId, r));
                                
      return Promise.all(resultPromises);
    })
    .then((results:AssessmentResult[]) => {
      // let processedResults = results;
      let reportVariables = this._reportData.variables || [];
      let reportComputedVariables = this._reportData.computedResults || [];
      let processedResults = this.processReportComputations(reportComputedVariables, results);
      let variables = this.resolveVariables(reportVariables, processedResults, clientId);
      console.log("variables: ", variables);
      this._reportData.items.forEach((i) => {
        if (i.display === false) {  // if we've disabled / hidden this item we want to skip over it.
          return;
        }
        let component = this.createComponent(i.type, i.data, processedResults, variables);
        let componentId = this.uniqueIdService.generate();
        this.componentItems.push(component);
        this.componentItemsById.set(componentId, component);
        this.addComponentToNavBar(i, componentId);
      });
      
      // console.log("Component item counts are: ", this.componentItems.length);
      Promise.all(this.componentItems.map(ci => {
        return ci.instance.itemLoaded().toPromise()
      })).then(items => {
        // fire off event on the dom
        // we need to let outside listeners like the server pdf generator know we have finished loading so we can generate the report
        console.log("adding dac-report-loaded class");
        document.body.classList.add("dac-report-loaded");
        // this.elementRef.nativeElement.dispatchEvent(new Event("dac-report-loaded", {bubbles:true}));
        this.hasLoadedResults = true;
        this.handleLoadedResize();
      })
      .catch((error) => {
        console.error(error);
        // console.log("dispatching dac-report-load-failed event");
        // this.elementRef.nativeElement.dispatchEvent(new Event("dac-report-load-failed", {bubbles:true}));
        this.hasLoadedResults = true;
      });
    });
  }

  get ReportName() {
    if (this._reportData) {
      return this._reportData.name;
    }
    return "";
  }

  public goBack() {
    // TODO: stephen we are dependent on a global here.. should inject angular dependency.
    window.history.back();
  }

  private handleLoadedResize() {
    let element = this.elementRef.nativeElement as HTMLElement;
    
    let height = element.ownerDocument.body.scrollHeight;
    let width = element.ownerDocument.body.scrollWidth;
    this.crossDomainMessenger.sendMessage('dac.report-loaded', {height: height, width: width, reportId: this.reportId});
  }

  private processReportComputations(computed_results:ResultComputation[], results:AssessmentResult[]) {
    
    if (!computed_results || !computed_results.length) {
      return results;
    }
    let newResults:AssessmentResult[];
    newResults = computed_results.map(cs => {
      let result = new AssessmentResult();
      // make the result and the assessment the same... then we can just refer to the assessment by the uid
      // and all our code works the same...
      result.id = cs.id;
      result.assessment = new Assessment();
      result.assessment.uid = cs.id;
      result.assessment.description = cs.description;
      result.assessment.name = cs.name;
      result.scaleResults.push(this.createScaleResultFromComputation(cs, results));

      return result;
    });
    return results.concat(newResults);
  }

  private createScaleResultFromComputation(computation:ResultComputation, results) {
    let scaleResult = new ScaleResult();
      if (computation.scale) {
        scaleResult.scale = this.hydrator.hydrateScale(computation.scale);
      }
      // calculation, assessments
      if (computation.items) {
        computation.items.forEach(i => this.processCalculation(scaleResult, i, computation.calculation, results));
        console.log("score is ", scaleResult.score);
        scaleResult.range = scaleResult.scale.getRangeForScore(scaleResult.score);
        console.log("new range is ", scaleResult.range);
      }
      return scaleResult;
  }

  private resolveVariables(variables:any[], results:AssessmentResult[], clientId:string) : Variable[] {
    let resolved:Variable[] = [];
    resolved = variables.map(v => {
      if (!v.type || !v.value) {
        return null;
      }
      var value = null;
      if (v.type == 'computed_scale_result') {
        return this.resolveComputedScale(v, results);
      }
      else if (v.type == 'scale_result') {  // this is actually the range... not the scaleResult
        return this.resolveResultScale(v, results);
      }
      else if (v.type == 'scale') {
        return this.resolveScale(v, results);
      }
    }).filter(v => v != null);
    resolved.push({id: "ClientToken", value: clientId})
    resolved.push({id: "reportTitle", value: this.ReportName});
    resolved.push({id: "logoURL", value: this.dacConfig.applicationLogoUrl});
    resolved.push({id: "reportHeaderImgURL", value: this.dacConfig.reportHeaderImgURL});
    return resolved;
  }
  private resolveResultScale(variableData:any, results:AssessmentResult[]) {
    let result = results.find(r => r.assessment.uid == variableData.assessmentUid);
    return this.resolveVariableFromResult(variableData, result);
  }
  private resolveScale(variableData:any, results:AssessmentResult[]) {
    let result = results.find(r => r.assessment.uid == variableData.assessmentUid);
    if (result) {
      let scaleResult = result.scaleResults.find(sr => sr.scale.id == variableData.scale);
      let value = scaleResult.scale[variableData.value];
      if (value) {
        return {id: variableData.id, value: value};
      }
    }
    return null;
  }
  private resolveVariableFromResult(variableData:any, result:AssessmentResult) {
    if (result) {
      let scaleResult = result.scaleResults.find(sr => sr.scale.id == variableData.scale);
      let value;
      if (variableData.value == 'score') {
        value = scaleResult.score;
      }
      else if (variableData.value == 'scorePercentage') {
        value = scaleResult.scorePercentage;
      }
      else {
        value = scaleResult.range[variableData.value];
      }
      
      if (value) {
        return {id: variableData.id, value: value};
      }
    }
    return null;
  }
  private resolveComputedScale(variableData:any, results:AssessmentResult[]) {
    let result = results.find(r => r.id == variableData.computedResultId);
   return this.resolveVariableFromResult(variableData, result);
  }

  private processCalculation(scaleResult:ScaleResult, item:any, calculation:string, results:AssessmentResult[]) {
    let result = results.find(r => r.assessment.uid == item.assessmentUid);
    let processScaleResult = result ? result.scaleResults.find(sr => sr.scale.id == item.scaleId) : null;
    if (!(result && processScaleResult)) {
      return;
    }
    if (calculation === "SUM") {
      scaleResult.score += processScaleResult.score;
    }
  }

  createComponent(type, data, results:AssessmentResult[], variables:Variable[]) : ComponentRef<IReportItemComponent> {
    let component = this.getComponentFromType(type);
    let factory = this.resolver.resolveComponentFactory(component);
    let componentRef = this.container.createComponent(factory);
    let reportItemComponent = componentRef.instance as IReportItemComponent;
    reportItemComponent.setReportData(data, results, variables);

    // add the specific classes for report items here
    if (componentRef.location && componentRef.location.nativeElement) {
      let reportItemClassNames = reportItemComponent.getHTMLClassNames() || [];
      let classNameString = this._reportItemClassNames.concat(reportItemClassNames).join(" ");
      let el = componentRef.location.nativeElement as Element;
      el.className = classNameString;
    }

    return componentRef;
  }

  private getNavIconClasses(itemId:string) {

  }

  private goToNavItem(item:NavBarItem) {
    // TODO: stephen use the navigator service instead of this one.
    if (!this.componentItemsById.has(item.id)) {
      console.error("tried to navigate to missing component with item id " + item.id);
      return;
    }

    let component = this.componentItemsById.get(item.id);
    let element = component.location.nativeElement;
    if (element) {
      // TODO: stephen change out this hack to accomodate the fixed navbar at the top.
      let navBar = document.querySelector("dac-navbar nav");
      let navBarHeight = navBar.clientHeight;

      // adapted from https://stackoverflow.com/a/13857312
      element.scrollIntoView(true);
      var scrolledY = window.scrollY;
      
      if(scrolledY){
        window.scroll(0, scrolledY - navBarHeight);
      }
    }
  }

  private addComponentToNavBar(data, componentId) {
    if (data.title && componentId) {
      this.navBarService.addReportNavBarItem(componentId, data.title);

      // let hasIcon = false;
      // let iconClasses = data.titleIconClasses;
      // if (iconClasses) {
      //   hasIcon = true;
      // }
      // this.menuItems.push({id: componentId, name: data.title, hasIcon:hasIcon, iconClasses:iconClasses});
    }
  }

  private getComponentFromType(type:string) {
    var component = null;
    switch (type)
    {
      case 'HTMLContentItem': {
        
        component = HtmlContentItemComponent;
      }
      break;
      case 'ScaleResultsSectionsList': {
        component = ScaleResultsSectionsListComponent;
      }
      break;
      case 'AddoScaleResults': {
        component = AddoScaleResultsComponent;
      }
      break;
      case 'ComputedScale': {
        component = ComputedScaleComponent;
      }
      break;
      case 'ScaleResultsSummary': {
        component = ScaleResultsSummaryComponent;
      }
      break;
      case 'TherapistScaleResults': {
        component = TherapistScaleResultsComponent;
      }
      break;
      case 'FlaggedQuestionsList': {
        component = FlaggedQuestionsListComponent;
      }
      break;
      case 'FlaggedQuestionsListSimple': {
        component = FlaggedQuestionsListSimpleComponent;
      }
      break;
      case 'PclAssessmentResults': {
        component = PclAssessmentResultsComponent;
      }
      break;
      case 'AssessmentQuestionsList': {
        component = AssessmentQuestionsListComponent;
      }
      break;
      case 'QuestionActionList': {
        component = QuestionActionListComponent;
      }
      break;
      case 'ClientScaleResults': {
        component = ClientScaleResultsComponent;
      }
      break;
      default: {
        component = TextItemComponent;
      }
      break;
    }
    return component;
  }
  
  public print() {
    this.showPrintDialog = true;
  }

  public closePrintDialog() {
    // reset it once we've closed the dialog.
    this.showPrintDialog = false;
    // this.displayTherapistNotes = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/reports/report-viewer/report-viewer.component.ts